<template>
  <div class="redpack-box" v-show="redpackList.length">
    <h1 class="flex-box">
      <img src="//img.233.com/union/wap/redpack-icon.png" alt="" />
      您获得{{redpackList.length}}个购课红包
    </h1>
    <ul>
      <li v-for="(item, index) in redpackList" :key="index">
        <div>
          ￥<span class="money">{{ item.value }}</span>
        </div>
        <div>满{{ item.label }}可用</div>
      </li>
    </ul>
  </div>
</template>

<script>
import { GetNewStudentRedPack } from "@/lib/request";
export default {
  components: {},
  name: "redpack-box",
  data() {
    return {
      redpackList: [
        {
          label: "4800",
          value: "580",
        },
        {
          label: "2400",
          value: "350",
        },
        {
          label: "1200",
          value: "150",
        },
        {
          label: "600",
          value: "60",
        },
        {
          label: "400",
          value: "40",
        },
        {
          label: "200",
          value: "20",
        },
      ],
    };
  },
  mounted() {
    GetNewStudentRedPack({}, (res) => {
      let { Result = [] } = res;
      if(Result && Result.length) {
        this.redpackList = Result.reverse().map(item => {
          return {
            label: item.Money,
            value: item.Pice
          }
        })
      }
    });
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.redpack-box {
  box-sizing: border-box;
  margin-top: 10px;
  background: url(//img.233.com/union/wap/hb_bg.png) no-repeat top center;
  background-color: #fff;
  background-size: contain;
  // height: 140px;
  border-radius: 4px;
  padding: 10px;
  h1 {
    font-size: 16px;
    color: #e13b29;
    img {
      margin-right: 5px;
      width: 37px;
    }
  }
  ul {
    text-align: center;
    margin-top: 10px;
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    list-style: none;
    li {
      box-sizing: border-box;
      list-style: none;
      padding: 8px 10px 10px;
      background: url(//img.233.com/union/wap/hb_item_bg.png) no-repeat top
        center;
      border-radius: 8px;
      width: 32%;
      font-size: 12px;
      color: #e13b29;
      &:not(:nth-of-type(3n)) {
        margin-right: 1%;
      }
      margin-bottom: 2%;
      .money {
        font-weight: bold;
        font-size: 24px;
      }
    }
  }
}
.flex-box {
  display: flex;
  align-items: center;
}
</style>
